'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (input) {
  return input.replace(/\(c\)/gim, '©').replace(/© *(\d)/gim, '© $1');
};

module.exports = exports['default'];

